import { takeLatest, put, call, SagaReturnType } from 'redux-saga/effects';
import { laborHoursConstant } from 'src/redux/actions/constant';
import laborHoursService from 'src/services/apiServices/laborHoursService/laborHoursService';

function* getPayPeriodCycles(action: any): SagaReturnType<any> {
  try {
    yield put({ type: laborHoursConstant.GET_PAY_PERIOD_CYCLES_LOADER });
    const response = yield call(laborHoursService.getPayPeriodCycles, action.payload);
    if (response?.status === 200) {
      yield put({
        type: laborHoursConstant.GET_PAY_PERIOD_CYCLES_SUCCESS,
        payload: response.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: laborHoursConstant.GET_PAY_PERIOD_CYCLES_FAILURE, payload: error });
  }
}

function* getPayPeriodCyclesSaga() {
  yield takeLatest(laborHoursConstant.GET_PAY_PERIOD_CYCLES_REQUEST, getPayPeriodCycles);
}

export default getPayPeriodCyclesSaga;
